var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreLayout, [
    _c(
      "div",
      { staticClass: "mb-5", class: { container: !_setup.isMobile } },
      [
        _c(_setup.InfoLayout, {
          staticClass: "pt-6",
          attrs: {
            "current-path": _setup.reverseFullL10N({
              name: "document",
              args: { language: _setup.urlLang },
            }),
            "is-policy": false,
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v("\n        " + _vm._s(_setup.pageTitle) + "\n      "),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _c(_setup.MainContent, {
                    attrs: { context: _setup.context },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }